import { Button, Image, InformationBox, Shimmer, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';

interface BillingPaymentMethodProps {
  readonly buttonText: string; // e.g. Manage Card, Update Payment Method
  readonly title?: string; // e.g. Mastercard ending in **34, Direct debit card ending in **34
  readonly caption?: string; // e.g. Expiry 12/25, Bank Mandiri
  readonly information?: string; // e.g. Billing to: johndoe@email.com
  readonly imageUrl?: string;
  readonly loading?: boolean;
  readonly buttonLoading?: boolean;
  readonly onClick?: () => void;
}

function BillingPaymentMethod({
  title,
  caption,
  information,
  buttonText,
  imageUrl,
  loading,
  buttonLoading,
  onClick,
}: BillingPaymentMethodProps) {
  return (
    <div className="grid flex-1 gap-2.5 rounded-xl bg-neutral-50 p-6">
      <div>
        <Text as="h4" variant="title-1" weight="medium">
          Payment Method
        </Text>
        <Text variant="body-2" className="mt-1 text-neutral-600">
          See this section to know your payment method and detail
        </Text>
      </div>
      <div className="flex items-center gap-4 rounded-xl bg-white px-6 py-2">
        <Image
          src={imageUrl}
          width={56}
          height={56}
          className={twMerge(!imageUrl && 'bg-neutral-100', 'rounded-md object-contain')}
          alt="Payment Method"
        />
        {loading ? (
          <div>
            <Shimmer size="md" className="mb-0.5" />
            <Shimmer size="sm" className="w-36" />
          </div>
        ) : (
          <div>
            {title ? <Text variant="body-2">{title}</Text> : null}
            {caption ? (
              <Text variant="caption-2" className="text-neutral-600">
                {caption}
              </Text>
            ) : null}
            {information ? (
              <Text variant="caption-2" className="text-neutral-400">
                {information}
              </Text>
            ) : null}
          </div>
        )}
      </div>
      <InformationBox variant="secondary" icon>
        to switch from Credit Card to Direct Debit vice versa, please call{' '}
        <Text as="a" href="tel:1500970" color="blue">
          1500970
        </Text>
      </InformationBox>
      <Button disabled={loading} onClick={onClick} loading={buttonLoading}>
        {buttonText}
      </Button>
    </div>
  );
}

export { BillingPaymentMethod };
